// extracted by mini-css-extract-plugin
export default {"logo":"Login_logo__42n1Y","login":"Login_login__3cJrA","form":"Login_form__HoQ6M"};